class PurchaseOptions extends HTMLElement {
  constructor() {
    super();
    this.sellingPlanParam = 'selling_plan';
    this.variantRadios = document.querySelector('variant-radios');
    this.purchaseOptionsInputs = this.querySelectorAll(
      'input[name="purchase_option"]'
    );
    this.oneTimePurchaseInput = this.querySelector(
      'input[id="one_time_purchase"]'
    );
    this.subscriptionInput = this.querySelector(
      'input[id="subscription_plan"]'
    );
    this.handleInputs();
    this.addEventListener('change', this.onSellingPlanChange);
    this.variantRadios?.addEventListener('change', this.onVariantChange);
  }

  onSellingPlanChange() {
    this.renderPurchaseOptionsInfo();
    this.updateUrl();
  }

  onVariantChange() {
    let subscriptionInput = document.querySelector(
      'input[id="subscription_plan"]'
    );

    if (subscriptionInput?.checked) {
      let selectedSellingPlanId =
        this.querySelector('input:checked')?.dataset.sellingPlanId;
      let sellingPlanInput = document.querySelector(
        'input[name="selling_plan"]'
      );
      if (sellingPlanInput) {
        sellingPlanInput.value = selectedSellingPlanId;
      }
    }

    let section = this.dataset.section.replace('quickadd-', '');
    let selectedVariantId =
      this.querySelector('input:checked')?.dataset.variantId;
    let fetchUrl = `${this.dataset.url}?variant=${selectedVariantId}`;

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        let amazonUrlDestination = document.querySelector(
          `#ProductInfo-${section} .amazon-button`
        );
        const amazonUrlSource = html.querySelector(
          `#ProductInfo-${section} .amazon-button`
        );

        if (amazonUrlDestination == null) {
          amazonUrlDestination = document.querySelector(
            `#ProductInfo-quickadd-${section} .amazon-button`
          );
        }

        if (amazonUrlSource && amazonUrlDestination) {
          amazonUrlDestination.innerHTML = amazonUrlSource.innerHTML;
          amazonUrlDestination.classList = amazonUrlSource.classList;
        }
      });
  }

  updateUrl() {
    let selectedSellingPlanId =
      this.variantRadios?.querySelector('input:checked')?.dataset.sellingPlanId;
    let selectedVariantId =
      this.variantRadios?.querySelector('input:checked')?.dataset.variantId;
    let pathname = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    if (this.subscriptionInput?.checked) {
      urlParams.set('selling_plan', selectedSellingPlanId);
    } else {
      urlParams.delete('selling_plan');
      urlParams.set('variant', selectedVariantId);
    }
    window.history.replaceState({}, '', pathname + '?' + urlParams.toString());
  }

  renderPurchaseOptionsInfo(type) {
    let fetchUrl;
    let fetchUrlQuickAdd;
    let selectedVariantId =
      this.variantRadios?.querySelector('input:checked')?.dataset.variantId;
    let section = this.dataset.section.replace('quickadd-', '');
    if (this.subscriptionInput?.checked) {
      let sellingPlanId = document.querySelector(
        `input[data-variant-id="${selectedVariantId}"]`
      )?.dataset.sellingPlanId;

      fetchUrl = `${this.dataset.url}?variant=${selectedVariantId}&selling_plan=${sellingPlanId}&section_id=${section}`;
      fetchUrlQuickAdd = `${this.dataset.url}?variant=${selectedVariantId}&selling_plan=${sellingPlanId}&section_id=sticky-quick-add`;
    } else {
      fetchUrl = `${this.dataset.url}?variant=${selectedVariantId}&section_id=${section}`;
      fetchUrlQuickAdd = `${this.dataset.url}?variant=${selectedVariantId}&section_id=sticky-quick-add`;
    }

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        let destination = document.getElementById(`ProductInfo-${section}`);
        const source = html.getElementById(`ProductInfo-${section}`);
        if (destination == null) {
          destination = document.getElementById(
            `ProductInfo-quickadd-${section}`
          );
        }

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }

        document
          .querySelector('variant-radios')
          ?.classList.remove('is-loading');
      });

    fetch(fetchUrlQuickAdd)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`sticky-quick-add`);
        const source = html.getElementById(`sticky-quick-add`);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }
      });
  }

  handleEvents() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has(this.sellingPlanParam)) {
      this.subscriptionInput?.setAttribute('checked', 'true');
      this.oneTimePurchaseInput?.removeAttribute('checked');
    } else {
      this.subscriptionInput?.removeAttribute('checked');
      this.oneTimePurchaseInput?.setAttribute('checked', 'true');
    }
  }

  handleInputs() {
    this.purchaseOptionsInputs.forEach((input) => {
      input.addEventListener('change', (e) => {
        if (e.target == this.oneTimePurchaseInput) {
          this.setUrl(false);
          this.handleEvents();
        } else {
          this.setUrl(true);
          this.handleEvents();
        }
      });
    });
  }

  setUrl(isSubscription) {
    let pathname = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    if (isSubscription == true) {
      urlParams.set(
        this.sellingPlanParam,
        this.subscriptionInput.dataset.sellingPlanId
      );
      window.history.replaceState(
        {},
        '',
        pathname + '?' + urlParams.toString()
      );
    } else {
      urlParams.delete(this.sellingPlanParam, '');
      window.history.replaceState(
        {},
        '',
        pathname + '?' + urlParams.toString()
      );
    }
  }
}

customElements.define('purchase-options', PurchaseOptions);

class SubscriptionToggle extends HTMLElement {
  constructor() {
    super();
    this.toggleBtn = this.querySelector('input[name="subscription-toggle"]');
    this.itemSellingPlanId = this.dataset.sellingPlanId;
    this.itemId = this.dataset.itemId;
    this.itemQty = this.dataset.itemQty;
    this.itemKey = this.dataset.itemKey;
    this.addEventListener('change', this.handleToggle);
  }

  handleToggle(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    let cartItemsSection = document.querySelector('[id$=cart-items]');
    let itemSubscriptionPrice = parseInt(this.dataset.itemSubscriptionPrice);
    if (this.toggleBtn.checked) {
      if (itemSubscriptionPrice == 0) {
        (async () => {
          let freeSubscriptionBody = JSON.stringify({
            id: this.itemKey,
            quantity: 1,
            selling_plan: this.itemSellingPlanId,
            sections: 'cart-drawer,cart-icon-bubble',
          });
          let regularItemQty = parseInt(this.itemQty) - 1;
          let regularItemBody = JSON.stringify({
            id: this.dataset.itemVariantId,
            quantity: regularItemQty,
            sections: 'cart-drawer,cart-icon-bubble',
          });

          // await resolveFreeSubscription(freeSubscriptionBody);
          // await resolveRegularItem(regularItemBody);

          const resolveFreeSubscription = await cartUpdate(
            window.Shopify.routes.root + 'cart/change.js',
            freeSubscriptionBody
          );
          const resolveRegularItem = await cartUpdate(
            window.Shopify.routes.root + 'cart/add.js',
            regularItemBody
          );
        })();
      } else {
        let body = JSON.stringify({
          id: this.itemKey,
          quantity: this.itemQty,
          selling_plan: this.itemSellingPlanId,
          sections: 'cart-drawer,cart-icon-bubble',
        });

        cartUpdate(window.Shopify.routes.root + 'cart/change.js', body);
      }
    } else {
      let body = JSON.stringify({
        id: this.itemKey,
        quantity: this.itemQty,
        selling_plan: null,
        properties: {
          _subscriptionToggleOn: 'true',
        },
        sections: 'cart-drawer,cart-icon-bubble',
      });
      cartUpdate(window.Shopify.routes.root + 'cart/change.js', body);
    }

    function cartUpdate(url, body) {
      return fetch(url, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: body,
      })
        .then((response) => response.json())
        .then((response) => {
          document.querySelector('cart-drawer').renderContents(response);
        })
        .then((response) => {
          if (cartItemsSection == undefined) {
            return;
          }
          fetch(
            window.Shopify.routes.root +
              `?section_id=${cartItemsSection.id
                .split('shopify-section-')
                .pop()}`
          )
            .then((response) => response.text())
            .then((responseText) => {
              const fetchedHtml = new DOMParser().parseFromString(
                responseText,
                'text/html'
              );
              const cartDestination = document.querySelector('.main-cart');
              const cartSource = fetchedHtml.querySelector('.main-cart');

              if (cartSource && cartDestination) {
                cartDestination.innerHTML = cartSource.innerHTML;
              }
            })
            .then((response) => {
              cartdrawerFreeShippingNote();
            });
        });
    }
  }
}

customElements.define('subscription-toggle', SubscriptionToggle);
